import PropTypes from 'prop-types';
import FJTitleLine from '../../../../common/combineComponents/FJTitleLine/FJTitleLine';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJTextAreaWidthInspire from '../../../../common/combineComponents/FJTextAreaWidthInspire/FJTextAreaWidthInspire';
import FJStylePicker from '../../../../common/combineComponents/FJStylePicker/FJStylePicker';
import { PRESET_STYLE_LIST } from '../../../../redux/slices/FJSliceAIAudioGenerator';
import FJSwitchButton from '../../../../common/components/FJSwitchButton/FJSwitchButton';
import FJTextarea from '../../../../common/components/FJTextarea/FJTextarea';
import styles from './FJAIAudioLeftT2M.module.less';
import FJUtil from '../../../../util/FJUtil';
import { MAX_PROMPT_LENGTH, MAX_LYRICS_LENGTH } from '../../../../config/dataConfig/FJAIAudioGeneratorData';
const FJAIAudioLeftT2M = ({
    subTabIndex,
    // 音乐生成相关
    getInspire,

    // 歌词相关
    lyricContent,
    onLyricContentChange,
    isEnableLyrics,
    onToggleLyrics,

    musicPrompt,
    onChangeMusicPrompt,

    // 风格
    musicStyles,
    onChangeMusicStyles,
}) => {
    const renderLyricsToggle = () => {
        return (
            <div className={styles.lyrics_toggle_box}>
                {isEnableLyrics && (
                    <div className={styles.text_limit}>
                        {FJUtil.getByteLen(lyricContent)}/{MAX_LYRICS_LENGTH}
                    </div>
                )}
                <FJSwitchButton active={isEnableLyrics} onChange={() => onToggleLyrics(!isEnableLyrics)} />
            </div>
        );
    };
    const musicStylesString =
        musicStyles.length > 0 ? ',' + musicStyles.map(style => FJLocalStore._(style)).join(',') : '';

    const CompoundWordsLength = FJUtil.getByteLen(musicPrompt + musicStylesString);

    return (
        <div>
            {subTabIndex === 0 && (
                <>
                    <FJTitleLine
                        title={FJLocalStore._('prompt')}
                        desc={FJLocalStore._('please-describe-the-tags-of-music-you-want-to-generate')}
                        isRequire={true}
                        style={{ marginTop: 0 }}
                        descWidth='360px'
                        isShowTry={false}
                        renderRight={() => (
                            <div className={styles.text_limit}>
                                {CompoundWordsLength}/{MAX_PROMPT_LENGTH}
                            </div>
                        )}
                    />
                    <FJTextAreaWidthInspire
                        hasGuide={false}
                        hasInspireInReight={false}
                        placeholder={FJLocalStore._('describe-the-tags-of-music-you-want-to-generate')}
                        getInspire={getInspire}
                        text={musicPrompt}
                        onChange={onChangeMusicPrompt}
                        maxByteLength={MAX_PROMPT_LENGTH - FJUtil.getByteLen(musicStylesString)}
                        customRightRender={() => (
                            <FJStylePicker
                                selectedOptions={musicStyles}
                                onChange={onChangeMusicStyles}
                                options={PRESET_STYLE_LIST}
                                className={styles.style_box}
                            />
                        )}
                        rows={3}
                        inspireLabel=''
                    />

                    <FJTitleLine
                        title={FJLocalStore._('self-written-lyrics')}
                        desc={
                            <>
                                <div className={styles.guide_title}>{FJLocalStore._('ttm-lyric-structure-guide')}</div>
                                <div className={styles.guide_format}>
                                    {FJLocalStore._('ttm-lyric-structure-format')}
                                </div>
                            </>
                        }
                        isRequire={false}
                        isShowTry={false}
                        isShowHelp={isEnableLyrics}
                        renderRight={renderLyricsToggle}
                        style={{ marginTop: 21, marginBottom: 10 }}
                        descWidth='300px'
                    />
                    <div data-expanded={isEnableLyrics} className={styles.lyrics_box}>
                        <FJTextarea
                            className={styles.lyrics_textarea}
                            placeholder={FJLocalStore._('enter-your-lyric-here')}
                            text={lyricContent}
                            onChange={e => onLyricContentChange(e.target.value)}
                            maxByteLength={MAX_LYRICS_LENGTH}
                        />
                    </div>
                    <FJTitleLine
                        title={FJLocalStore._('music-duration')}
                        isRequire={false}
                        isShowTry={false}
                        isShowHelp={false}
                        style={{ marginTop: isEnableLyrics ? 20 : 10, marginBottom: 6 }}
                        descWidth='300px'
                    />
                    <div className={styles.duration_desc}>
                        {FJLocalStore._('music-length-is-determined-by-the-lyrics-max-300-seconds')}
                    </div>
                </>
            )}
        </div>
    );
};

FJAIAudioLeftT2M.propTypes = {
    subTabIndex: PropTypes.number.isRequired,
    onChangeSubTab: PropTypes.func.isRequired,
    // 音乐生成相关
    getInspire: PropTypes.func.isRequired,
    musicDuration: PropTypes.number.isRequired,
    onChangeMusicDuration: PropTypes.func.isRequired,
    instrumentalDuration: PropTypes.number.isRequired,
    onChangeInstrumentalDuration: PropTypes.func.isRequired,

    // 歌词相关
    lyricContent: PropTypes.string,
    onLyricContentChange: PropTypes.func,
    onLyricDescChange: PropTypes.func,
    lyricDesc: PropTypes.string,
    generateLyrics: PropTypes.func,
    isGenerateLyricsLoading: PropTypes.bool,
    isEnableLyrics: PropTypes.bool,
    onToggleLyrics: PropTypes.func,

    // 风格
    musicStyles: PropTypes.array,
    instrumentStyles: PropTypes.array,
    onChangeMusicStyles: PropTypes.func.isRequired,
    onChangeInstrumentStyles: PropTypes.func.isRequired,

    // prompt
    musicPrompt: PropTypes.string,
    instrumentalPrompt: PropTypes.string,
    onChangeMusicPrompt: PropTypes.func,
    onChangeInstrumentalPrompt: PropTypes.func,
};

export default FJAIAudioLeftT2M;
